import { NotificationWindowOptions, useShellNotificationSettingsStore } from '@frontend/shell-utils';
import { createStore } from '@frontend/store';

type NotificationsStore = {
  placement: NotificationWindowOptions['placement'];
  mode: 'new';
};

//This makes sure we have backwards compatibility until the user has updated to the latest version of the app
const modePlacementFeature = window.shell?.featureAvailability?.has?.('mode-placement');
const zustandSyncFeature = window.shell?.featureAvailability?.has?.('zustand-sync');

export const useNotificationsStore = createStore<NotificationsStore>(
  () => ({
    mode: 'new',
    placement: 'top-right',
  }),
  {
    name: 'notifications-store',
  }
);

if (window.shell) {
  if (zustandSyncFeature) {
    // Primary path: hydrate from the synced Zustand store (auto-populated by ipcSync
    // when the shell pushes initial state via shellBridge.setState).
    const syncPlacement = () => {
      const placement = useShellNotificationSettingsStore.getState().placement;
      if (placement) {
        useNotificationsStore.setState({ placement });
      }
    };
    // Hydrate immediately with current value
    syncPlacement();
    // Keep in sync on future changes
    useShellNotificationSettingsStore.subscribe(syncPlacement);
  } else if (modePlacementFeature) {
    // Backward-compat: old shell without zustand-sync
    window.shell?.invoke('notification:initial-state', undefined).then((state) => {
      if (!state) return;
      useNotificationsStore.setState({
        placement: state.placement,
      });
    });
  }
}
